import { IIdName } from '@/interfaces/general/IIdName.ts';

export const onsiteGbRegionOptions: Array<IIdName> = [
    { id: 'Eastern', name: 'Eastern' },
    { id: 'East_Midlands', name: 'East Midlands' },
    { id: 'London', name: 'London' },
    { id: 'Merseyside_North_Wales', name: 'Merseryside North Wales' },
    { id: 'Midlands', name: 'Midlands' },
    { id: 'Northern', name: 'Northern' },
    { id: 'North_Western', name: 'North Western' },
    { id: 'Southern', name: 'Southern' },
    { id: 'South_Eastern', name: 'South Eastern' },
    { id: 'South_Wales', name: 'South Wales' },
    { id: 'South_Western', name: 'South Western' },
    { id: 'Yorkshire', name: 'Yorkshire' },
    { id: 'South_Scotland', name: 'South Scotland' },
    { id: 'North_Scotland', name: 'North Scotland' },
];

export const onsiteGermanRegionOptions: Array<IIdName> = [
    { id: 'North_West', name: 'North West' },
    { id: 'North_East', name: 'North East' },
    { id: 'West', name: 'West' },
    { id: 'Central', name: 'Central' },
    { id: 'South_West', name: 'South West' },
    { id: 'South_East', name: 'South East' },
];

export const gridConnectionOptions: Array<IIdName> = [
    { id: 'Transmission', name: 'Transmission' },
    { id: 'EHV132', name: '132kV' },
    { id: 'EHV33', name: '33kV' },
    { id: 'HV', name: 'HV' },
    { id: 'LV', name: 'LV' },
];

export const tnuosZoneOptions: Array<IIdName> = [
    { id: 'NorthScotland', name: '1) North Scotland' },
    { id: 'EastAberdeenshire', name: '2) East Aberdeenshire' },
    { id: 'WesternHighlands', name: '3) Western Highlands' },
    { id: 'SkyeLochalsh', name: '4) Skye and Lochalsh' },
    { id: 'EasternGrampianTayside', name: '5) Eastern Grampian and Tayside' },
    { id: 'CentralGrampian', name: '6) Central Grampian' },
    { id: 'Argyll', name: '7) Argyll' },
    { id: 'Trossachs', name: '8) The Trossachs' },
    { id: 'StirlingshireFife', name: '9) Stirlingshire and Fife' },
    { id: 'SouthWestScotlands', name: '10) South West Scotlands' },
    { id: 'LothianBorders', name: '11) Lothian and Borders' },
    { id: 'SolwayCheviot', name: '12) Solway and Cheviot' },
    { id: 'NorthEastEngland', name: '13) North East England' },
    { id: 'NorthLancashireLakes', name: '14) North Lancashire and The Lakes' },
    { id: 'SouthLancashireYorkshireHumber', name: '15) South Lancashire, Yorkshire and Humber' },
    { id: 'NorthMidlandsNorthWales', name: '16) North Midlands and North Wales' },
    { id: 'SouthLincolnshireNorthNorfolk', name: '17) South Lincolnshire and North Norfolk' },
    { id: 'MidWalesMidlands', name: '18) Mid Wales and The Midlands' },
    { id: 'AngleseySnowdon', name: '19) Anglesey and Snowdon' },
    { id: 'Pembrokeshire', name: '20) Pembrokeshire' },
    { id: 'SouthWalesGloucester', name: '21) South Wales & Gloucester' },
    { id: 'Cotswold', name: '22) Cotswold' },
    { id: 'CentralLondon', name: '23) Central London' },
    { id: 'EssexKent', name: '24) Essex and Kent' },
    { id: 'OxfordshireSurreySussex', name: '25) Oxfordshire, Surrey and Sussex' },
    { id: 'SomersetWessex', name: '26) Somerset and Wessex' },
    { id: 'WestDevonCornwall', name: '27) West Devon and Cornwall' },
];

export const tlfZoneOptions: Array<IIdName> = [
    { id: 'Eastern', name: 'Eastern' },
    { id: 'East_Midlands', name: 'East Midlands' },
    { id: 'London', name: 'London' },
    { id: 'Merseyside_North_Wales', name: 'Merseyside North Wales' },
    { id: 'Midlands', name: 'Midlands' },
    { id: 'Northern', name: 'Northern' },
    { id: 'North_Western', name: 'North Western' },
    { id: 'Southern', name: 'Southern' },
    { id: 'South_Eastern', name: 'South Eastern' },
    { id: 'South_Wales', name: 'South Wales' },
    { id: 'South_Western', name: 'South Western' },
    { id: 'Yorkshire', name: 'Yorkshire' },
    { id: 'South_Scotland', name: 'South Scotland' },
    { id: 'North_Scotland', name: 'North Scotland' },
];

export const locationalBalancingRegionOptions: Array<IIdName> = [
    { id: '1', name: 'North Scotland (North of B2)' },
    { id: '2', name: 'Central Scotland (B2 to B4)' },
    { id: '3', name: 'South Scotland (B4 to B6)' },
    { id: '4', name: 'North England (B6 to B7a)' },
    { id: '5', name: 'North Central England and North Wales (B7a to B8)' },
    { id: '6', name: 'South Central England and South Wales (B8 to SC1)' },
    { id: '7', name: 'East Anglia (East of EC5)' },
    { id: '8', name: 'South England (South of SC1)' },
];

export const cmContractOptions: Array<IIdName> = [
    { id: 'None', name: 'None' },
    { id: 'Existing', name: 'Existing' },
    { id: 'Refurbishment', name: 'Refurbishment' },
    { id: 'NewBuild', name: 'New Build' },
];

export const cmContractDurations: Array<IIdName> = [
    { id: 'None', name: '0' },
    { id: 'Existing', name: '1' },
    { id: 'Refurbishment', name: '3' },
    { id: 'NewBuild', name: '15' },
];

export const germanCfDOptions: Array<IIdName> = [
    { id: 'DE_EEG', name: 'Feed in Premium (EEG)' },
];
